import { getRooms, setRooms } from './redux/slices/roomsSlice';
import { useDispatch } from 'react-redux';

// pages
import HomePage from './pages/HomePage'; 
import NotFoundPage from './pages/NotFoundPage'; 
import { HashRouter, Route, Routes } from 'react-router-dom';
import React, { useEffect } from 'react';
import RoomPage from './pages/RoomPage';
import EditPage from './pages/EditPage';

const App = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getRooms())
        // mock data
        //dispatch(setRooms(roomData)) 
    },[])

    return(
        <HashRouter>
            <React.Suspense fallback="loading">
                <Routes>
                {/* pages */}
                    <Route path="/" element={<HomePage />} />
                    <Route path="*" element={<NotFoundPage />}/> 
                    <Route path="/room" element={<RoomPage />}/>
                    <Route path="/admin" element={<EditPage />}/>
                </Routes>
            </React.Suspense>      
        </HashRouter>
    )
};

export default App;